"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useExtendedFormContext = void 0;
var _react = require("react");
var _reactHookForm = require("react-hook-form");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useExtendedFormContext = exports.useExtendedFormContext = function useExtendedFormContext() {
  var formContext = (0, _reactHookForm.useFormContext)();
  var hookFormSetValue = formContext.setValue;

  /**
   * Define new method to set value and validate since 
   * react-hook-form@7.29.x doesn't provide support for dependent
   * fields validation when changing field value via `setValue`
   */
  var setValueAndValidate = (0, _react.useCallback)(function (name, value, deps, options) {
    hookFormSetValue(name, value, options);
    setTimeout(function () {
      if (deps && formContext) {
        var dirtyOrTouchedFields = deps.filter(function (name) {
          var fieldState = formContext.getFieldState(name);
          return fieldState.isDirty || fieldState.isTouched;
        });
        formContext.trigger(dirtyOrTouchedFields);
      }
    }, 0);
  }, [formContext, hookFormSetValue]);
  return _objectSpread(_objectSpread({}, formContext), {}, {
    setValueAndValidate: setValueAndValidate
  });
};